/**
 * Thumb-reachable bottom navigation, shown instead of the top nav below `lg`.
 *
 * The top bar could not hold six links on a phone: they overflowed to 444px on a
 * 375px screen inside a scroller with no affordance, at 28px tall. A tab bar puts
 * the same destinations within thumb reach at a tappable size, which is what
 * every native app does for the same reason.
 */

import { NavLink } from 'react-router-dom'
import { tabItems } from './nav-items'

export default function MobileTabBar({ signedIn }: { signedIn: boolean }) {
  const items = tabItems(signedIn)
  if (items.length === 0) return null

  return (
    <nav
      aria-label="Main"
      // pb-safe clears the iOS home indicator; without it the last few pixels of
      // the tab row sit under the system gesture bar and swallow taps.
      className="mobile-tabs pb-safe z-30 shrink-0 border-t border-ink-800 bg-ink-900/95 backdrop-blur lg:hidden"
    >
      <ul className="flex items-stretch justify-around">
        {items.map((item) => (
          <li key={item.to} className="flex-1">
            <NavLink
              to={item.to}
              className={({ isActive }) =>
                `flex min-h-[52px] flex-col items-center justify-center gap-1 px-1 py-1.5
                 text-[10px] font-semibold transition ${
                   isActive ? 'text-brand-400' : 'text-ink-500 active:text-slate-300'
                 }`
              }
            >
              {({ isActive }) => (
                <>
                  {/* The pill behind the icon carries the active state, so it does
                      not rely on the label colour alone. */}
                  <span
                    className={`grid h-7 w-12 place-items-center rounded-full transition ${
                      isActive ? 'bg-brand-500/15' : ''
                    }`}
                  >
                    <item.icon className="h-[22px] w-[22px]" />
                  </span>
                  <span className="tab-label">{item.short}</span>
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  )
}
